import { useQuery } from "@tanstack/react-query";
import { getTargetareStats } from "@/api/endpoints/targetare";
import { queryKeys } from "@/lib/queryClient";
import { jobActiv } from "@/utils/targetareJoburi";

export function useGetTargetareStats() {
  return useQuery({
    queryKey: queryKeys.targetare.stats(),
    queryFn: getTargetareStats,
    select: (response) => response.data,
    staleTime: 1000 * 60,
    retry: 1,
    refetchInterval: (query) =>
      jobActiv(query.state.data?.data.joburi ?? []) ? 5000 : false,
    refetchIntervalInBackground: true,
  });
}
